// Do NOT add "use client" to this file
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import * as React from "react";

import { ProductImageWithSrcsetSizes } from "@faire/retailer/features/MarketplaceItems/ProductImageWithSrcsetSizes";

import { IProductImageProps, ProductImage } from "../ProductImage";

interface ITileImageProps {
  image: IImage;
  imageAltText: string | undefined;
  showVerticalImagery?: boolean;
  imageDimension?: IProductImageProps["imageDimension"];
  imageContainerRef?: React.MutableRefObject<HTMLDivElement | null>;
  useLazyImageLoading?: boolean;
  imageBreakpoints?: string;
  onLoad?: () => void;
}

export const TileImage: React.FC<ITileImageProps> = ({
  image: primaryImage,
  showVerticalImagery,
  imageDimension,
  imageContainerRef,
  imageAltText,
  useLazyImageLoading,
  imageBreakpoints,
  onLoad,
}) => {
  //Set the image dimension to match productImage -> COMMON_TILE_IMAGE_DIMENSION
  return (
    <div
      key={primaryImage.token}
      ref={imageContainerRef}
      data-test-id={`carousel-image-${primaryImage.token}`}
    >
      {imageBreakpoints ? (
        <ProductImageWithSrcsetSizes
          image={primaryImage}
          alt={imageAltText ?? ""}
          loading={useLazyImageLoading ? "lazy" : undefined}
          sizes={imageBreakpoints}
          showVerticalImagery={showVerticalImagery}
          onLoad={onLoad}
        />
      ) : (
        <ProductImage
          key={primaryImage.token}
          image={primaryImage}
          imageDimension={
            imageDimension ?? {
              mobileAndAbove: 370,
              tabletAndAbove: 350,
              xLargeAndAbove: 300,
            }
          }
          showVerticalImagery={showVerticalImagery}
          alt={imageAltText ?? ""}
          useLazyImageLoading={useLazyImageLoading}
          imageBreakpoints={imageBreakpoints}
          shouldIncrementallyLoadImages
          onLoad={onLoad}
        />
      )}
    </div>
  );
};
